<button type="button" class="formula-icon icon-btn">
    <svg
        #formula="ngbPopover"
        [ngbPopover]="formulaPopover"
        [placement]="['right-top', 'left-top']"
        containerClass="formula-popover-body"
        popoverClass="formula-popover"
        container="body"
        type="button"
        (click)="getFormula(); checkOpen();"
        [ngClass]="checkOpen() ? 'active-icon' : null"
        class="icon-20">
        <use href="../App_Themes/clearview-default/icons/utility/formula.svg#formula"></use>
    </svg>
</button>

<ng-template #formulaPopover>
    <div class="formula-popover-body">
        <div class="formula-title">
            <div cvLocalizedText [langSection]="'Calculated_Metric_Breakdown'" [langKey]="'Formula_Definition'">Formula Definition</div>
            <svg class="icon-16 close-formula-popover"><use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use></svg>
        </div>
        <div class="formula-metrics">{{ formulaString }}</div>
    </div>
</ng-template>
